import { render, staticRenderFns } from "./ValueType.vue?vue&type=template&id=fb5b962c"
import script from "./ValueType.vue?vue&type=script&lang=js"
export * from "./ValueType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb5b962c')) {
      api.createRecord('fb5b962c', component.options)
    } else {
      api.reload('fb5b962c', component.options)
    }
    module.hot.accept("./ValueType.vue?vue&type=template&id=fb5b962c", function () {
      api.rerender('fb5b962c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/ValueType.vue"
export default component.exports